import { TransactionInterface } from "@/types/pledgeService";

export const transactionDisplayKey = (item: TransactionInterface): string =>
  item.display_id ?? `${item.payment_type}:${item.id}`;

export const transactionDisplayAmount = (item: TransactionInterface): number | undefined => {
  if (item.renewal_stage && item.display_amount != null) return Number(item.display_amount);
  if (item.payment_type?.toLowerCase() !== "renewal") return item.total_amount ?? item.paid_amount;
  if (item.pledge?.is_uploan === true && Number(item.uploan_amount) > 0) {
    return Number(item.uploan_amount);
  }
  return (
    Number(item.interest_amount ?? 0) +
    Number(item.pledge?.admin_fee ?? item.admin_fee ?? 0) +
    (item.pledge?.is_downloan === true ? Number(item.downloan_amount ?? 0) : 0)
  );
};
